import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const VaaIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99582)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H24V24H0V12H3V8H8V12ZM4.632 20.016L2.83 14H1L3.775 22H5.495L8.28 14H6.445L4.632 20.016ZM12.137 20.352L12.692 22H14.445L11.451 14H9.923L6.945 22H8.698L9.248 20.352H12.137ZM9.692 19.016L10.687 16.022L11.692 19.016H9.692ZM19.709 20.352L20.264 22H22.016L19.022 14H17.495L14.516 22H16.269L16.819 20.352H19.709ZM17.264 19.016L18.258 16.022L19.264 19.016H17.264ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99582'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

VaaIcon.displayName = 'VaaIcon'
